import type {
    OrganizationTaskTemplateCreate,
    OrganizationTaskTemplateUpdate,
} from "@common/contracts/organization-task-template.contract";
import { isPlainObject } from "@common/helpers/typeGuards";
import { OrganizationTaskTemplate } from "@common/types/organizationTaskTemplate";
import type { AddTaskResult } from "../OrganizationCloseTemplates/AddCloseTemplateTaskDrawer";
import type { EditTaskResult } from "../OrganizationCloseTemplates/EditCloseTemplateTaskDrawer";
import type { LocalTask } from "../OrganizationCloseTemplates/closeTemplateTasksDrawer.types";
import type { OrganizationTaskTemplateRow } from "./organizationTaskTemplatesViewConfig";

export const toTemplateRow = (
    template: OrganizationTaskTemplate,
): OrganizationTaskTemplateRow => ({
    id: template.id,
    name: template.title,
    closeStageId: template.closeStageId,
    assigneeRole: template.assigneeRole,
    taskType: template.type,
    externalDeadline: template.externalDeadline,
    deadlineAnchor: template.deadlineAnchor,
    estimatedTime: template.estimatedTime,
});

export const toLocalTask = (template: OrganizationTaskTemplate): LocalTask => ({
    localId: template.id,
    persistedId: template.id,
    name: template.title,
    closeStageId: template.closeStageId,
    assigneeRole: template.assigneeRole,
    assigneeId: template.assigneeId,
    externalDeadline: template.externalDeadline,
    deadlineAnchor: template.deadlineAnchor,
    estimatedTime: template.estimatedTime,
    taskType: template.type,
    initialMessage: template.initialMessage,
    viewConfig: isPlainObject(template.viewConfig) ? template.viewConfig : null,
    sourceTemplateId: null,
    sourceTemplateVersion: null,
    isDeleted: false,
    order: 0,
    blockedByLocalIds: [],
    relatedLocalIds: [],
});

const toSharedBody = (
    result: Omit<EditTaskResult, "taskType" | "sourceTemplateVersion">,
) => ({
    title: result.name,
    closeStageId: result.closeStageId,
    assigneeRole: result.assigneeRole,
    assigneeId: result.assigneeId,
    externalDeadline: result.externalDeadline,
    deadlineAnchor: result.deadlineAnchor,
    estimatedTime: result.estimatedTime,
    initialMessage: result.initialMessage,
    viewConfig: result.viewConfig,
});

export const toCreateBody = (
    result: AddTaskResult,
): OrganizationTaskTemplateCreate => ({
    ...toSharedBody(result),
    type: result.taskType,
});

export const toUpdateBody = (
    result: EditTaskResult,
): OrganizationTaskTemplateUpdate => toSharedBody(result);
